<template>
  <div>
    <h2>Special Editions</h2>

    <v-card class="pa-2 mt-5 d-flex">
      <v-text-field
        outlined
        hide-details
        v-model="search"
        label="Search list"
        prepend-inner-icon="mdi-star"
      ></v-text-field>
      <v-btn
        icon
        x-large
        text
        class="ml-2 mt-1 mr-1"
        color="green"
        @click="createSpecialEdition = true"
      >
        <v-icon>mdi-star-plus-outline </v-icon>
      </v-btn>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="filteredEditions"
      :items-per-page="10"
      class="elevation-1 mt-5 mb-8"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        <small>{{ formatDate(item.createdAt) }}</small>
      </template>
      <template v-slot:[`item.title`]="{ item }">
        <span style="white-space: nowrap">
          <v-tooltip v-if="item.active" bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="green" v-bind="attrs" v-on="on">
                mdi-check-circle-outline
              </v-icon>
            </template>
            <span>active edition</span>
          </v-tooltip>

          <v-tooltip v-else bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="red" v-bind="attrs" v-on="on">
                mdi-close-circle-outline
              </v-icon>
            </template>
            <span>inactive edition</span>
          </v-tooltip>

          {{ item.title }}
        </span>
      </template>
      <template v-slot:[`item._id`]="{ item }">
        <span style="white-space: nowrap">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="blue"
                class="ma-1"
                v-bind="attrs"
                v-on="on"
                @click="openDetailsDialog(item._id)"
              >
                <v-icon>mdi-star-cog-outline</v-icon>
              </v-btn>
            </template>
            <span>update edition</span>
          </v-tooltip>

          <!-- <v-btn icon color="red" class="ma-1">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn> -->
        </span>
      </template>
    </v-data-table>

    <EditionDetails
      :edition="selectedEdition"
      @refresh="fetchSpecialEditions"
      @cancel="selectedEdition = null"
    />

    <CreateEdition
      @refresh="fetchSpecialEditions"
      :open="createSpecialEdition"
      @cancel="createSpecialEdition = false"
    />
  </div>
</template>

<script>
import { formatDateOnly } from "../../../tools/format";
import EditionDetails from "./Dialogs/EditionDetails";
import CreateEdition from "./Dialogs/CreateEdition";

export default {
  components: { CreateEdition, EditionDetails },

  data: () => ({
    loading: false,
    createSpecialEdition: false,

    editions: [],

    search: "",

    headers: [
      { text: "Created", value: "createdAt" },
      { text: "Year", value: "year" },
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      { text: "Actions", value: "_id", sortable: false },
    ],

    selectedEdition: null,
  }),

  computed: {
    filteredEditions() {
      return [...this.editions].filter((edition) => {
        const term = this.search.toLowerCase();
        return (
          edition.title.toLowerCase().includes(term) ||
          (edition.description &&
            edition.description.toLowerCase().includes(term))
        );
      });
    },
  },

  methods: {
    formatDate: formatDateOnly,
    fetchSpecialEditions() {
      this.loading = true;
      this.$axios
        .get("/special-editions")
        .then(({ data: response }) => {
          this.editions = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve special editions",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetailsDialog(edition) {
      this.$forceUpdate();
      this.selectedEdition = edition;
    },
  },

  mounted() {
    this.fetchSpecialEditions();
  },
};
</script>